import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import styles from './SearchBar.module.scss';

import Input from '../Input/Input';

type SearchBarProps = {
  placeholder: string;
  className?: string;
  style?: React.CSSProperties;
  initialState?: 'default' | 'active' | 'hover' | 'typing';
  initialText?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus?: () => void;
  onBlur?: () => void;
};

const SearchBar: React.FC<SearchBarProps> = ({
  placeholder,
  className,
  style,
  initialState = 'default',
  initialText = '',
  value: externalValue,
  onChange,
  onFocus,
  onBlur,
}) => {
  const [value, setValue] = useState(initialText);
  const [isFocused, setIsFocused] = useState(false);
  const [isTyping, setIsTyping] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    if (initialState === 'active') {
      setIsFocused(true);
    }
    if (initialState === 'typing') {
      setIsFocused(true);
      setIsTyping(true);
    }
    if (initialState === 'hover') {
      setIsHovered(true);
    }
  }, [initialState]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setValue(newValue);
    setIsTyping(newValue.length > 0);
    onChange?.(e);
  };

  return (
    <div
      className={clsx(styles.searchBarWrapper, className, {
        [styles.focused]: isFocused,
        [styles.typing]: isTyping,
        [styles.hover]: isHovered || initialState === 'hover',
      })}
      style={style}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Input
        type='search'
        value={value}
        placeholder={placeholder}
        className={styles.input}
        onChange={handleInputChange}
        onFocus={() => {
          setIsFocused(true);
          onFocus?.();
        }}
        onBlur={() => {
          setIsFocused(false);
          onBlur?.();
        }}
      />
    </div>
  );
};

export default SearchBar;
